import { BrowserCacheLocation, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';
import { APP } from '../constants/api-endpoints';

const authority = `https://login.microsoftonline.com/${environment.azureAd.tenantId}`;

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.azureAd.clientId,
    authority,
    redirectUri: APP.callback,
    postLogoutRedirectUri: APP.login,
    navigateToLoginRequestUrl: false
  },
  cache: {
    //cacheLocation: BrowserCacheLocation.LocalStorage
    cacheLocation: BrowserCacheLocation.SessionStorage
  }
});

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', environment.azureAd.apiScope]
};

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map()
  };
}
